<!-- Adapted from swingmx/webclient src/components/HomeView/Browse.vue at
     f0b87657c6450dc12d2dfd286b75f501410dcabd (MIT, Mungai Njoroge).
     Template and grid/flex structure retained; routes/counts come from this app.
     SaltUI Item content stays inside real links to preserve browser navigation. -->
<template>
  <nav class="homebrowse" aria-label="音乐快捷入口">
    <div class="browselist">
      <router-link v-for="item in items" :key="item.title" class="browseitem" :to="item.route">
        <SaltItem class="browse-action interactive" :title="item.title">
          <template #leading><svg-icon :icon-class="item.icon" /></template>
          <template v-if="item.count !== undefined" #trailing>{{ item.count }}</template>
        </SaltItem>
      </router-link>
    </div>
  </nav>
</template>
<script>
import SaltItem from '../ui/SaltItem.vue';
export default { name: 'SwingBrowse', components: { SaltItem }, props: { items: { type: Array, default: () => [] } } };
</script>
<style scoped>
.homebrowse { padding:0 0 16px; }
.browselist { display:flex; flex-wrap:wrap; gap:8px; }
.browseitem { box-sizing:border-box; display:block; min-width:0; min-height:32px; border-radius:999px; overflow:hidden; background:transparent; color:inherit; font-weight:400; cursor:default; -webkit-tap-highlight-color:transparent; }
.browse-action { --salt-item-icon:16px; --salt-sub-padding:6px; padding:6px 12px; color:inherit; }
.browse-action ::v-deep .item-copy { padding:0; font-size:14px; }
.browse-action ::v-deep .trailing { margin-inline-start:8px; font-size:12px; }
.browseitem:focus-visible { outline:none; }
.browseitem:focus-visible ::v-deep .browse-action::after { background:var(--salt-hover-overlay); }
</style>
